import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-smb',
  templateUrl: './smb.component.html',
  styleUrls: ['./smb.component.css']
})
export class SmbComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - SMB';
    var description = 'Continuous Compliance Automation Platform for Highly Regulated Industries';
    var keywords = 'RegScale, SMB, Small, Medium, Business, CMMC, compliance, cyber security, audits, cost savings, issues management, vendor management';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
